import { render } from "./pLog.vue?vue&type=template&id=667345d8&scoped=true"
import script from "./pLog.vue?vue&type=script&lang=js"
export * from "./pLog.vue?vue&type=script&lang=js"

import "./pLog.vue?vue&type=style&index=0&id=667345d8&scoped=true&lang=css"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667345d8"]])

export default __exports__